/**
 * Created by razial on 2026-04-16.
 */

cleverapps.Tool.rewardedPromo = ToolFolder.create(() => ({
    tryWindow: function () {
        const rewardedPromo = cleverapps.rewardedPromo;

        if (!rewardedPromo.promotion) {
            rewardedPromo.startPromotion();
        }

        if (!rewardedPromo.promotion) {
            return;
        }

        cleverapps.focusManager.closeAllWindows();
        rewardedPromo.displayTryWindow();
    },
    allowTryWindow: function () {
        const rewardedPromo = cleverapps.rewardedPromo;

        rewardedPromo.guideShown = true;
        rewardedPromo.lastShown = 0;
        rewardedPromo.save();
    },
    startPromotion: ToolFolder.create(() => {
        const projects = {};

        Object.keys(RewardedPromoConfig.PROJECTS).forEach((projectId) => {
            projects[projectId] = function () {
                const rewardedPromo = cleverapps.rewardedPromo;

                rewardedPromo.reset();
                rewardedPromo.startPromotion(projectId);
                cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
            };
        });

        return projects;
    }),
    incCompleted: function () {
        const promotion = cleverapps.rewardedPromo.promotion;
        if (!promotion) {
            return;
        }
        const task = promotion.tasks.find((t) => !t.isCompleted());
        if (!task) {
            return;
        }
        promotion.completed |= (1 << task.config.bit);
        connector.multi.rewardedpromo.updateData(cleverapps.rewardedPromo.crossId, {
            completed: promotion.completed
        });
        promotion.tasks.forEach((t) => t.onUpdate());
        cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
    },
    setTimeLeft: function () {
        const promotion = cleverapps.rewardedPromo.promotion;
        if (!promotion || !promotion.started) {
            return;
        }
        displayToolPrompt((minutes) => {
            const timeRemain = cleverapps.parseInterval("1 minute") * parseFloat(minutes);
            if (Number.isNaN(timeRemain)) {
                return;
            }
            promotion.finish = Date.now() + timeRemain;
            connector.multi.rewardedpromo.updateData(cleverapps.rewardedPromo.crossId, { finish: promotion.finish });
            cleverapps.sideBar.resetByClassName(RewardedPromoIcon);
        }, "Time left in minutes", "1");
    },
    reset: function () {
        cleverapps.rewardedPromo.reset();
    },
    resetEvents: function () {
        // clear the per-crossId dedup so cpromo_available/shown/firstlaunch can log again
        cleverapps.rewardedPromo.loggedAvailable = false;
        cleverapps.rewardedPromo.loggedShown = false;
        cleverapps.rewardedPromo.loggedFirstLaunch = false;
        cleverapps.rewardedPromo.save();
    },
    gotoGameByLink: function () {
        if (!cleverapps.rewardedPromo.promotion) {
            return;
        }
        displayToolPrompt((linkOrId) => {
            if (linkOrId) {
                connector.platform.switchGame(linkOrId.trim(), cleverapps.rewardedPromo.promotion.getPayload());
            }
        }, "Enter link or instant gameId", undefined);
    }
}));

cleverapps.Tool.UI.windows.tryRewardedPromoWindow = function () {
    const rewardedPromo = cleverapps.rewardedPromo;

    if (!rewardedPromo.promotion) {
        rewardedPromo.startPromotion();
    }

    if (!rewardedPromo.promotion) {
        const projectId = Object.keys(RewardedPromoConfig.PROJECTS).find((id) => {
            const sources = RewardedPromoConfig.PROJECTS[id].sources;
            return !sources || sources.includes(cleverapps.config.name);
        });

        if (projectId) {
            rewardedPromo.startPromotion(projectId);
        }
    }

    if (!rewardedPromo.promotion) {
        return;
    }

    displayToolWindow(() => {
        new TryRewardedPromoWindow(rewardedPromo.promotion);
    })();
};